// Widget CSS
import '@/css/_elementor/widgets/logo_marquee.css';

// ..........................................................................................

// import { ShuffleColors } from '@/js/utilities/color-shuffle';

// ..........................................................................................

// Hook into Elementor frontend init
window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/logo_marquee.default', (scope) => {
		const scopeEl = scope[0];
		// ...

		const marqueeContainer = scopeEl.querySelector('.marquee-container');

		if (!marqueeContainer) return;

		// ...

		// const shuffledColors = new ShuffleColors({
		// 	container: marqueeContainer,
		// 	items: '.logo-wrapper',
		// 	colors: ['#F7C228', '#A9B1F8', '#7CD8A1', '#61A2F8', '#E74C28', '#C9D0FC', '#94C3FC'],
		// });

		// ...

		// const groups = marqueeContainer.querySelectorAll('.marquee-group');

		// groups.forEach((group) => {
		// 	const clone = group.cloneNode(true); // deep clone
		// 	group.insertAdjacentElement('afterend', clone);
		// });

		if (!window.elementor) {
			const groups = marqueeContainer.querySelectorAll('.marquee-group');
			groups.forEach((group) => {
				setTimeout(() => {
					group.classList.add('is-active');
				}, 100);
			});
		}

		// ...
	});
});

// ..........................................................................................
